import PendingVerificationRoutes from "./router/pending-router.js";

export default [PendingVerificationRoutes];